export default "__VITE_ASSET__BtqFszay__"